import { render, staticRenderFns } from "./DialogCollector.vue?vue&type=template&id=a4c65b70"
import script from "./DialogCollector.vue?vue&type=script&lang=js"
export * from "./DialogCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports